export type CartShopKey = "store" | `seller:${string}`;

export function productLineKey(productId: string): string {
  return `p:${productId}`;
}

export function packLineKey(packId: string): string {
  return `pack:${packId}`;
}

export function listingLineKey(listingId: string): string {
  return `l:${listingId}`;
}

export function shopKeyForSeller(sellerId: string): CartShopKey {
  return `seller:${sellerId}`;
}

export function keysForStore(
  productIds: string[],
  packIds: string[],
): string[] {
  return [...productIds.map(productLineKey), ...packIds.map(packLineKey)];
}

export function keysForSellerGroup(listingIds: string[]): string[] {
  return listingIds.map(listingLineKey);
}

export function parseSellerId(shop: CartShopKey): string | null {
  return shop === "store" ? null : shop.slice("seller:".length);
}
